import isElement from "lodash.iselement";
import removeCartItem from "../api/removeCartItem.js";
import updateCartItem from "../api/updateCartItem.js";
import Full from "../components/full.js";
import Quantity from "../components/quantity.js";

class CartEntry {
  constructor(base) {
    if (!isElement(base)) return;
    this.base = base;
    this._checked = false;
    this.init();
  }
  init() {
    // Get product id
    this.id = parseInt(this.base.parentElement.dataset.id);
    if (!Number.isInteger(this.id)) return;
    // Get product key
    this.key = this.base.parentElement.dataset.key;

    // Init checkbox
    this._checkbox = this.base.querySelector(".checkbox");
    if (isElement(this._checkbox)) {
      this._checkbox.addEventListener("click", this.toggleChecked.bind(this));
    }
    // Init remove button
    this._removeButton = this.base.querySelector(".remove");
    if (isElement(this._removeButton)) {
      this._removeButton.addEventListener("click", this.remove.bind(this));
    }
    // Init full card link
    this._link = this.base.querySelector(".entry__title");
    if (isElement(this._link)) {
      this._link.addEventListener("click", e => {
        e.preventDefault();
        this.openFull();
      });
    }
    // Init quantity widget
    const quantityElement = this.base.querySelector(".quantity");
    const availableElement = this.base.querySelector(".available[data-value]");
    if (quantityElement && availableElement) {
      this._quantity = new Quantity({
        base: quantityElement,
        limit: availableElement.dataset.value,
        onChange: (newCount) => {
          const callback = response => {
            if (typeof miniShop2 !== "undefined") {
              miniShop2.Cart.status(response);
            }
          };

          updateCartItem(this.key, newCount, callback);

          const oldPriceOne = parseFloat(this.base.querySelector('.entry__price .entry__price-old span').innerHTML);
          const priceOne = parseFloat(this.base.querySelector('.entry__price .entry__price-real span').innerHTML);
          const sumOld = this.base.querySelector('.entry__sum .entry__sum-old span');
          const sum = this.base.querySelector('.entry__sum .entry__sum-real span');

          sumOld.innerHTML = (oldPriceOne * newCount).toFixed(1);
          sum.innerHTML = (priceOne * newCount).toFixed(1);
        }
      });
    } 
  }
  setChecked() {
    this._checked = true;
    this._checkbox.classList.add("checkbox--active");
  }
  toggleChecked() {
    this._checked = !this._checked;
    if (this._checked) {
      this._checkbox.classList.add("checkbox--active");
    } else {
      this._checkbox.classList.remove("checkbox--active");
    }
  }
  isChecked() {
    return this._checked;
  }
  openFull() {
    this.full = new Full({
      id: this.id, 
      quantity: this._quantity.value,
      onQuantityChange: this._quantity.setValue.bind(this._quantity)
    });
  }
  remove() {
    this.base.style.opacity = 0;
    const afterTransition = () => {
      this.base.parentElement.remove();
      const callback = response => {
        if (typeof miniShop2 !== "undefined") {
          miniShop2.Cart.status(response);
        }
      };
      setTimeout(() => removeCartItem(this.key, callback), 500);
    };
    setTimeout(afterTransition, 400);
  }
}

export default CartEntry;



// WEBPACK FOOTER //
// ./src/js/components/cartEntry.js